module.exports = __webpack_public_path__ + "img/eye-background-blue.974bc79a.svg";